import React from 'react';
import { focusSquare } from '../../data/guide/monsterPhotoSheets';
type Crop = {
  sheetW: number;
  sheetH: number;
  rect: [number, number, number, number];
  focus?: {
    fx: number;
    fy: number;
    zoom: number;
  };
};

/**
 * Muestra un cuadro cuadrado enfocado en UN ejemplar, extraído primero del recorte de su foto en la lámina
 * (sin rótulos ni celdas vecinas) y luego encuadrado con el punto de enfoque y zoom guardados por ID.
 * Todo se calcula en porcentajes: funciona igual si la lámina se sirve a otra resolución.
 * El mismo encuadre se usa en miniaturas, fichas y vista previa.
 */
export function CroppedPhoto({
  src,
  crop,
  alt,
  fit,
  lazy = true,
  className = '',
  onError,
  onLoad
}: {
  src: string;
  crop: Crop;
  alt: string;
  /** `cover`: llena un contenedor ya dimensionado. `full`: el contenedor toma forma cuadrada por sí mismo. */
  fit: 'cover' | 'full';
  lazy?: boolean;
  className?: string;
  onError?: () => void;
  onLoad?: () => void;
}) {
  const {
    sheetW: W,
    sheetH: H
  } = crop;
  const [sx, sy, side] = focusSquare(crop.rect, crop.focus);
  const pct = (n: number) => `${n * 100}%`;
  return <span className={`relative block overflow-hidden ${className}`} style={fit === 'full' ? {
    aspectRatio: '1 / 1'
  } : undefined} data-id="element-1152" data-mp="1inylo3y0drwp">
      <img src={src} alt={alt} loading={lazy ? 'lazy' : 'eager'} decoding="async" draggable={false} onError={onError} onLoad={onLoad} className="absolute" style={{
      width: pct(W / side),
      height: pct(H / side),
      left: pct(-sx / side),
      top: pct(-sy / side),
      maxWidth: 'none'
    }} data-id="element-1153" data-mp="13yau3ufmq7m6" />
    </span>;
}